import { SVGProps, Ref, forwardRef } from 'react';

export const PenFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1 23v-6.071L12.828 5.101l6.071 6.07L7.071 23zM20.172 9.9l1.57-1.572a4.293 4.293 0 1 0-6.07-6.07L14.1 3.827z"
                fill="currentColor"
            />
        </g>
    </svg>
));
PenFilledSize24Glyph.displayName = 'PenFilledSize24Glyph';
